export default __webpack_public_path__ + "static/media/watt_3_but_jr_owns_it.09999ca9.mp3";